import '../../../proStoreCategories/index.mjs';
import { UniFiChildCategorySlug, UniFiCategoryId } from '../../../proStoreCategories/mapping/unifi.mjs';
import { SiteId } from '../../../../contexts/MenuContext/mapping.mjs';
import '../../assets/Assets-V4/WiFi/basestation-XG@2x.jpg.mjs';
import '../../assets/WiFi/basestation-xg.jpg.mjs';
import { wifiOutdoor } from '../product-list-groups/wifi-outdoor.mjs';
import '../properties/index.mjs';
import { wifiTechnology } from '../properties/wifiTechnology.mjs';
import { radio6Ghz } from '../properties/radio6Ghz.mjs';
import { extendedRangeMode6Ghz } from '../properties/extendedRangeMode6Ghz.mjs';
import { dedicatedSpectral } from '../properties/dedicatedSpectral.mjs';
import { rfFilteringTechnology } from '../properties/rfFilteringTechnology.mjs';
import { antennaType } from '../properties/antennaType.mjs';
import { wifiCoverage } from '../properties/coverage.mjs';
import { connectedDevices } from '../properties/connectedDevices.mjs';
import { weatherproofing } from '../properties/weatherproofing.mjs';
import { powerMethodPoe } from '../properties/powerMethodPoe.mjs';
import { uplink } from '../properties/uplink.mjs';
import { redundantRj45Port } from '../properties/redundantRj45Port.mjs';
import { wifiMounting } from '../properties/wifiMounting.mjs';
import { fipsCompliance } from '../properties/fipsCompliance.mjs';
import v3Image__default from "../../../../assets/basestation-xg.jpg";
import image__default from "../../../../assets/basestation-XG@2x.jpg";
"use strict";
const baseStationXG = {
  id: "baseStationXG",
  title: "baseStationXG.title",
  techspecsPath: [SiteId.TechSpecs, `/unifi/${UniFiCategoryId.WiFi}/uwb-xg`],
  storePathParts: {
    productSlug: "uwb-xg",
    category: UniFiChildCategorySlug.WiFiMegaCapacity
  },
  descriptionMaxWidth: 320,
  image: {
    src: image__default,
    width: 200,
    height: 160
  },
  v3Image: {
    src: v3Image__default,
    height: 183,
    width: 335
  },
  sku: "UWB-XG",
  description: "baseStationXG.description",
  productListGroup: wifiOutdoor,
  propertyValues: [{
    propertyId: "dimensions",
    value: {
      type: "string",
      value: '471.1 x 257.5 x 94.3 mm\n(18.6 x 10.1 x 3.7")'
    }
  }, {
    propertyId: wifiTechnology.id,
    value: {
      type: "translation",
      value: "baseStationXG.wifiTechnology"
    }
  }, {
    propertyId: radio6Ghz.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: extendedRangeMode6Ghz.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: dedicatedSpectral.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: "wifiPowerMethod",
    value: {
      type: "string",
      value: "PoE++"
    }
  }, {
    propertyId: rfFilteringTechnology.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: antennaType.id,
    value: {
      type: "translation",
      value: "baseStationXg.antennaType.selectableDirectional",
      asterisk: 1
    }
  }, {
    propertyId: wifiCoverage.id,
    value: {
      type: "translation",
      value: "baseStationXG.wifiCoverage"
    }
  }, {
    propertyId: connectedDevices.id,
    value: {
      type: "string",
      value: "1,500+"
    }
  }, {
    propertyId: weatherproofing.id,
    value: {
      type: "string",
      value: "IP67"
    }
  }, {
    propertyId: powerMethodPoe.id,
    value: {
      type: "string",
      value: "PoE++"
    }
  }, {
    propertyId: uplink.id,
    value: {
      type: "string",
      value: "10 GbE"
    }
  }, {
    propertyId: redundantRj45Port.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: wifiMounting.id,
    value: {
      type: "translation",
      value: "commons.mounting.wallPole"
    }
  }, {
    propertyId: fipsCompliance.id,
    value: {
      type: "boolean",
      value: false
    }
  }],
  notes: ["baseStationXG.notes.1"]
};
export { baseStationXG };
//# sourceMappingURL=baseStationXG.mjs.map
